export { Textarea, type TextareaProps } from './styled/textarea'
